export default "6fd70300b7e19aa1.ttf"